import * as React from "react";
function SvgCar(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.78 12H8c-1.328 0-2.168.33-2.713.738-.548.411-.886.97-1.088 1.578A5.58 5.58 0 003.938 16H5.17a3.001 3.001 0 015.658 0h2.342a3.001 3.001 0 015.658 0H20v-1c0-1.127-.13-2.125-.36-3H8.78zm.764-2h9.293C17.657 7.94 15.762 7 14 7c-1.378 0-2.55.72-3.46 1.686-.41.436-.743.896-.996 1.314zM3 18h2.17a3.001 3.001 0 005.66 0h2.34a3.001 3.001 0 005.66 0H21a1 1 0 001-1v-2c0-6.423-3.826-10-8-10-2.122 0-3.784 1.113-4.915 2.314-.84.891-1.456 1.902-1.802 2.713-1.328.104-2.381.5-3.196 1.11-.95.714-1.488 1.655-1.786 2.547-.295.885-.364 1.75-.364 2.379a8.236 8.236 0 00.071 1.069l.004.02v.008l.001.002v.001L3 17l-.986.164A1 1 0 003 18zm13 0a1 1 0 100-2 1 1 0 000 2zm-7-1a1 1 0 10-2 0 1 1 0 002 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCar);
export default ForwardRef;
